import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { User } from "../../_models/user";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-admin-shift-delivery-create',
  templateUrl: './admin-shift-delivery-create.component.html',
  styleUrls: ['./admin-shift-delivery-create.component.scss'],
})
export class AdminShiftDeliveryCreateComponent implements OnInit {

  carrierName: string;
  carrierNameError: string;
  accessKey: string;
  accessKeyError: string;
  secretKey: string;
  secretKeyError: string;

  constructor(private alertService: AlertService, private g: Globals, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {

  }

  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.carrierName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  accessKeyBlur() {
    this.accessKeyError = "";
    if (!this.accessKey) {
      this.accessKeyError = 'Please enter access key';
    }
  }

  secretKeyBlur() {
    this.secretKeyError = "";
    if (!this.secretKey) {
      this.secretKeyError = 'Please enter secret key';
    }
  }

  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.accessKeyError = "";
    this.secretKeyError = "";

    if (!this.carrierName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.accessKey) {
      this.accessKeyError = 'Please enter access key';
    }
    if (!this.secretKey) {
      this.secretKeyError = 'Please enter secret key';
    }
    if (this.carrierNameError != "" || this.accessKeyError != "" || this.secretKeyError != "") {
      this.g.loaderDisplay = "";
      return false;
    }

    // api body

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/verifyAndSaveCarrierCredentials', {
      "accessKey": this.accessKey,
      "carrierCode": "SD",
      "connectionName": this.carrierName,
      "organizationId": 1,
      "secretkey": this.secretKey
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Shift Delivery', 'Create Successfully');
          this.router.navigate(['/admin/adminCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }
}
